export { default } from './EducationSystemAf.jsx';
